<template>
    <div v-if="pageList.length > 3">
        <div class="md_pagination">
            <div class="link">
                <template v-for="(link, p) in pageList" :key="p">
                    <a v-if="link.url == null && p == 0 " class="chevron _previous _pagination_pointer"><span></span></a>
                    <a v-else-if="link.url == null" class="chevron _next _pagination_pointer"><span></span></a>
                    <a v-else-if="link.label.match(/laquo/)" class="chevron _previous _pagination_pointer" v-on:click="$inertia.visit(link.url, { method: 'get' })"><span></span></a>
                    <a v-else-if="link.label.match(/raquo/)" class="chevron _next _pagination_pointer" v-on:click="$inertia.visit(link.url, { method: 'get' })"><span></span></a>
                    <a v-else class="_pagination_pointer" v-bind:class="{ '_current': link.active }" v-on:click="$inertia.visit(link.url, { method: 'get' })"><span>{{link.label}}</span></a>
                </template>
            </div>
            <div class="control">
                <span>{{current_page}} / {{last_page}}</span>
            </div>
        </div>
    </div>
</template>
<style>
    ._pagination_pointer {
        cursor: pointer;
    }
</style>
<script>
    export default {
        data() {
            return {
                current_page: '',
                last_page: '',
            }
        },
        props: {
            list: Object
        },
        mounted() {
            this.current_page = this.list.current_page;
            this.last_page = this.list.last_page;
        },
        computed: {
            pageList() {
                var pagelinks = [];
                // iが5+2(2は前と次)以上の場合はそのままreturn
                if (this.list.links.length < 7) {
                    return this.list.links;
                }
                for(var i in this.list.links) {
                    var link = this.list.links[i];

                    if (link.label.match(/前/) || link.label.match(/次/)) {
                        pagelinks.push(link);
                        continue;
                    }

                    // current_pageが最初の場合
                    if (this.list.current_page == 1) {
                        if (link.label == 2 || link.label == 3 || link.label == 4 || link.label == 5) {
                            pagelinks.push(link);
                            continue;
                        }
                    }

                    // current_pageが最初から2番目の場合
                    if (this.list.current_page == 2) {
                        if (link.label == 1 || link.label == 3 || link.label == 4 || link.label == 5) {
                            pagelinks.push(link);
                            continue;
                        }
                    }

                    var last_ans = this.list.last_page - this.list.current_page;
                    // current_pageが最後の場合
                    if (last_ans == 0) {
                        if (link.label == this.list.last_page - 1 || link.label == this.list.last_page - 2 || link.label == this.list.last_page - 3 || link.label == this.list.last_page - 4) {
                            pagelinks.push(link);
                            continue;
                        }
                    }

                    // current_pageが最後から2番目の場合
                    if (last_ans == 1) {
                        if (i == this.list.current_page + 1 || link.label == this.list.last_page - 2 || link.label == this.list.last_page - 3 || link.label == this.list.last_page - 4) {
                            pagelinks.push(link);
                            continue;
                        }
                    }

                    // current_pageが中間の場合
                    var ans = link.label - this.list.current_page;
                    if (ans == -2 || ans == -1 || ans == 0 || ans == 1 || ans == 2) {
                        pagelinks.push(link);
                    }
                }

                return pagelinks;
            },
        },
    }
</script> 
